module.exports = __webpack_public_path__ + "img/technology4.274bc562.jpeg";